.radio-group{display:flex;flex-direction:row;margin:15px 0}.radio-group mat-radio-button{margin-right:auto}
/*# sourceMappingURL=select-default-template-dialog.component-U54OYJ23.css.map */
